import { Controller } from "stimulus";
// TODO split logics into different controllers in order to avoid complicated/multi-purpose controllers
export default class extends Controller {
  static targets = ["modal", "code"];

  static values = {
    url: String,
  };

  connect() {}

  generateCode(e) {
    e.preventDefault();
    fetch(this.urlValue)
      .then((response) => response.json())
      .then((data) => {
        this.codeTarget.textContent = data.pick_up_code;
        $(this.modalTarget).modal("show");
      });
  }
}
